import { render, staticRenderFns } from "./RolesReact.vue?vue&type=template&id=392f3466&"
import script from "./RolesReact.vue?vue&type=script&lang=js&"
export * from "./RolesReact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports